import React, { ChangeEvent, memo } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { StyledSortButton, TitleCheckbox } from '@modules/shortlist/components/ShortlistTable/index.styles'
import { useSortProfileValuesMap } from '@modules/shortlist/hooks/useSortProfileValuesMap'
import { ShortlistSortProfileValue, ShortlistTableHeadProps } from '@modules/shortlist/types'
import Typography from '@mui/material/Typography'

interface ProfileTitleHeadCellProps {
  allProfilesSelected: ShortlistTableHeadProps['allProfilesSelected']
  onSelectAllProfiles: ShortlistTableHeadProps['onSelectAllProfiles']
  sort: ShortlistSortProfileValue
  isSortActive: boolean
  openSortPopover: (params: { fieldName: string; anchor: HTMLElement }) => void
  hasLeftOffset?: boolean
}
const ManageTableProfileTitleHeadCell = (props: ProfileTitleHeadCellProps) => {
  const { allProfilesSelected, onSelectAllProfiles, sort, isSortActive, openSortPopover, hasLeftOffset = true } = props
  const { t } = useTranslation()

  const sortProfileValuesMap = useSortProfileValuesMap()

  return (
    <>
      <TitleCheckbox
        $hasLeftOffset={hasLeftOffset}
        checked={allProfilesSelected}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          onSelectAllProfiles(e.target?.checked)
        }}
      />
      <Typography variant="h3">{t(translationKeys.CUSTOM_LIST_TABLE_HEADER_TITLE)}</Typography>
      <StyledSortButton
        isActive={isSortActive}
        order={isSortActive ? sortProfileValuesMap[sort].order : null}
        onClick={({ btnElement }) => {
          openSortPopover({ fieldName: 'profileTitle', anchor: btnElement })
        }}
      />
    </>
  )
}

export default memo(ManageTableProfileTitleHeadCell)
